module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-rili_list"
  }, [(_vm.active === 'economics') ? _c('economics-list', {
    attrs: {
      "datas": _vm.economicsDatas
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'stockAfter') ? _c('economics-list', {
    attrs: {
      "datas": _vm.stockAfter,
      "none-text": "今日无股票财报数据"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'stockPre') ? _c('economics-list', {
    attrs: {
      "datas": _vm.stockPre,
      "none-text": "今日无股票财报数据"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'stockHk') ? _c('economics-list', {
    attrs: {
      "datas": _vm.stockHk,
      "none-text": "今日无股票财报数据"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'events') ? _c('events-list', {
    attrs: {
      "datas": _vm.eventsDatas
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'holiday') ? _c('holiday-list', {
    attrs: {
      "datas": _vm.holidayDatas
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7657522a","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/modules/MobileContent/index.vue
// module id = zXvW
// module chunks = 3